var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1503_1742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62625 10.3332C6.56674 10.1025 6.44648 9.89191 6.278 9.72343C6.10952 9.55495 5.89897 9.43469 5.66825 9.37517L1.57825 8.32051C1.50847 8.3007 1.44706 8.25867 1.40333 8.2008C1.3596 8.14293 1.33594 8.07238 1.33594 7.99984C1.33594 7.9273 1.3596 7.85675 1.40333 7.79888C1.44706 7.74101 1.50847 7.69898 1.57825 7.67917L5.66825 6.62384C5.89889 6.56438 6.10938 6.44422 6.27786 6.27587C6.44633 6.10751 6.56663 5.8971 6.62625 5.66651L7.68092 1.57651C7.70053 1.50645 7.74251 1.44474 7.80047 1.40077C7.85843 1.35681 7.92917 1.33301 8.00192 1.33301C8.07467 1.33301 8.14542 1.35681 8.20337 1.40077C8.26133 1.44474 8.30332 1.50645 8.32292 1.57651L9.37692 5.66651C9.43644 5.89722 9.5567 6.10777 9.72518 6.27625C9.89366 6.44473 10.1042 6.56499 10.3349 6.62451L14.4249 7.67851C14.4953 7.69791 14.5573 7.73985 14.6015 7.79789C14.6457 7.85594 14.6696 7.92688 14.6696 7.99984C14.6696 8.0728 14.6457 8.14374 14.6015 8.20179C14.5573 8.25983 14.4953 8.30177 14.4249 8.32117L10.3349 9.37517C10.1042 9.43469 9.89366 9.55495 9.72518 9.72343C9.5567 9.89191 9.43644 10.1025 9.37692 10.3332L8.32225 14.4232C8.30265 14.4932 8.26067 14.5549 8.20271 14.5989C8.14475 14.6429 8.074 14.6667 8.00125 14.6667C7.92851 14.6667 7.85776 14.6429 7.7998 14.5989C7.74184 14.5549 7.69986 14.4932 7.68025 14.4232L6.62625 10.3332Z",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 2V4.66667",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.33301H12",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66797 11.333V12.6663",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12H2",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1503_1742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8f46a54385f5402d7fcf816b46188519.svg";
export { ForwardRef as ReactComponent };